import React from 'react';
import '../css/about/About.css';
import SEO from './SEO';

const About = () => {
  return (
    <>
      <SEO 
        title="About Samapaw - Trusted Wealth Management Partner"
        description="Learn about Samapaw - Samapaw Sampatti Pvt Ltd founded in 2022. Samapaw specializes in strategic investment, property development, and wealth management. Your trusted Samapaw partner in building sustainable wealth in Gurugram, Haryana."
        keywords="about Samapaw, about Samapaw Sampatti, Samapaw company, Samapaw wealth management company Gurugram, Samapaw property investment company, Samapaw financial services Haryana, Samapaw investment advisory firm India, Sama paw company"
        section="about"
      />
      <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-header text-center">
            <h2>About Samapaw Sampatti</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle">
              Building sustainable wealth through strategic investments and property development
            </p>
          </div>

          <div className="about-grid">
            <div className="about-text">
              <div className="about-card">
                <div className="card-icon">
                  <i className="fas fa-bullseye"></i>
                </div>
                <h3>Our Objective</h3>
                <p>
                  Investment, development and trading in movable and immovable property. 
                  We specialize in identifying, acquiring, and maximizing the value of 
                  properties across diverse sectors, ensuring sustainable returns for 
                  our stakeholders.
                </p>
              </div>

              <div className="about-card">
                <div className="card-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h3>Our Approach</h3>
                <p>
                  With a data-driven approach and deep market insights, we create 
                  comprehensive investment strategies that balance risk and opportunity. 
                  Our experienced team ensures every investment decision is backed by 
                  thorough analysis and market understanding.
                </p>
              </div>
            </div>

            <div className="about-features">
              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <div className="feature-content">
                  <h4>Trust & Transparency</h4>
                  <p>Built on principles of integrity and clear communication</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-lightbulb"></i>
                </div>
                <div className="feature-content">
                  <h4>Innovation</h4>
                  <p>Leveraging modern techniques and market insights</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-users"></i>
                </div>
                <div className="feature-content">
                  <h4>Expert Team</h4>
                  <p>Led by qualified professionals with proven track records</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-trophy"></i>
                </div>
                <div className="feature-content">
                  <h4>Excellence</h4>
                  <p>Committed to delivering superior results and value</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mission-vision">
            <div className="mission-item">
              <h3>
                <i className="fas fa-compass"></i>
                Mission
              </h3>
              <p>
                To be the preferred partner for individuals and institutions seeking 
                strategic property investments, providing innovative solutions that 
                create lasting wealth and value.
              </p>
            </div>

            <div className="vision-item">
              <h3>
                <i className="fas fa-eye"></i>
                Vision
              </h3>
              <p>
                To become a leading force in the property investment sector, recognized 
                for our expertise, integrity, and commitment to creating sustainable 
                wealth for our clients and stakeholders.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default About;